import type { ElementRef, RefObject } from 'react';
import type { ValidationErrors } from '@frontend/utils';
import { calculateOffset } from '@frontend/utils';

const validationErrorSelector = '.has-danger';

export function scrollToValidationErrorByClassName(className: string): void {
    const selectors = `.${className} ${validationErrorSelector}`;
    scrollToError(selectors);
}

export function scrollToValidationError(noThrow?: boolean): void {
    scrollToError(validationErrorSelector, noThrow);
}

export function scrollToFormControlFeedback(noThrow?: boolean): void {
    const selectors = '.form-control-feedback';
    scrollToError(selectors, noThrow);
}

export function scrollValidationErrorIntoView(): void {
    const warning = document.querySelector(validationErrorSelector);
    warning?.scrollIntoView({ block: 'center' });
}

function scrollToError(selectors: string, noThrow?: boolean): void {
    const warning = document.querySelector(selectors);
    if (warning) {
        window.scrollTo(0, window.pageYOffset + warning.getBoundingClientRect().top - 150);
    } else if (Boolean(noThrow) === false) {
        throw new Error(`Unable to jump to Error: ${selectors}`);
    }
}

export function scrollToRefValidationError(ref: RefObject<ElementRef<'form' | 'div'>>): void {
    const warning = ref.current?.querySelector('.has-danger');
    const offset = calculateOffset();

    if (warning && offset) {
        window.scrollTo(0, window.scrollY + warning.getBoundingClientRect().top + offset);
    }
}

export function scrollValidationErrorIntoCenterViewInScrollContainer(id: string, errors: ValidationErrors) {
    const warning = document.querySelector(`#${id} .has-danger`);
    if (warning) {
        warning.scrollIntoView({ block: 'center' });
    } else {
        throw new Error(`Unable to jump to Error: ${id}. Error keys: ${errors.keySeq().join(', ')}.`);
    }
}
